import { loadUi } from "../lib/uiMemory";

export const LEAD_COLUMNS = [
  ["customer", "客户", "Customer", 180], ["sales", "负责人", "Sales", 120],
  ["address", "地址", "Address", 220], ["contact", "联系方式", "Contact", 180],
  ["source", "来源", "Source", 120], ["stage", "阶段", "Stage", 180],
  ["temperature", "意向", "Temp", 100], ["tags", "标签", "Tags", 180],
  ["score", "评分", "Score", 90], ["next", "下次跟进", "Next", 130],
  ["creator", "创建人", "Created by", 120], ["created", "创建时间", "Created", 130],
];
export const MIN_COLUMN_WIDTH = 80;
export const MAX_COLUMN_WIDTH = 600;

export function readLeadColumns(username) {
  const stored = username ? loadUi("crm_lead_columns", username) : null;
  const hidden = Array.isArray(stored?.hidden) ? stored.hidden.filter(k => k !== "customer" && LEAD_COLUMNS.some(c => c[0] === k)) : [];
  const widths = {};
  LEAD_COLUMNS.forEach(([key, , , fallback]) => {
    const value = stored?.widths?.[key];
    widths[key] = typeof value === "number" && Number.isFinite(value) ? Math.max(MIN_COLUMN_WIDTH, Math.min(MAX_COLUMN_WIDTH, value)) : fallback;
  });
  return { hidden, widths };
}

export function buildLeadMonths(months, params, now = new Date()) {
  const keyOf = (date) => {
    const parts = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Los_Angeles", year: "numeric", month: "2-digit" }).formatToParts(date);
    const values = Object.fromEntries(parts.map((p) => [p.type, p.value]));
    return `${values.year}-${values.month}`;
  };
  const counts = Object.fromEntries(months.map((m) => [m._id, m.count]));
  const dated = months.map((m) => m._id).filter((m) => m !== "unknown" && m !== "future").sort();
  const current = keyOf(now);
  const end = params.created_to ? keyOf(new Date(new Date(params.created_to).getTime() - 1)) : current;
  const upper = end < current ? end : current;
  const lower = params.created_from ? keyOf(new Date(params.created_from)) : (dated[0] || upper);
  const groups = [];
  let [year, month] = upper.split("-").map(Number);
  while (`${year}-${String(month).padStart(2, "0")}` >= lower) {
    const key = `${year}-${String(month).padStart(2, "0")}`;
    groups.push({ _id: key, count: counts[key] || 0 });
    if (--month === 0) { month = 12; year -= 1; }
  }
  if (counts.future) groups.push({ _id: "future", count: counts.future });
  if (counts.unknown) groups.push({ _id: "unknown", count: counts.unknown });
  return groups;
}
